
import TeeTimeIndex from '../components/tee_times/TeeTimeIndex.vue';
import Vue from 'vue';

Vue.component('tee-time-index', TeeTimeIndex);

export default Vue.extend({});
